import { VideoAvatar } from "components/ai/dialog/components/VideoAvatar";

const Avatar = (props) => {
  const { videoAvatarUrl, imageUrl, onZoomClick, isShowVideoAvatar } = props;

  return (
    <div className="avatar_placeholder mr-2">
      <VideoAvatar
        videoUrl={videoAvatarUrl}
        imageUrl={imageUrl}
        onClick={() => onZoomClick(imageUrl)}
        isShowVideoAvatar={isShowVideoAvatar}
      />
    </div>
  );
};

export default Avatar;
